module.exports = __webpack_public_path__ + "static/placeholder-ai-cd-2f9f5549549ab75fb1f2125cdeb6cd32.png";